<template>
  <div class="im-box">
    <!--    <i class="el-icon-close icon" @click="closeClick" title="关闭"></i>-->
    <iframe frameborder="0" width="100%" height="100%" ref="im"
            :src="imSrc + '?chatId=' + account.chatId + '&sdktoken=' + account.chatKey + '&token=' + account.token + '&realTime=true&v=' + Math.random()" allow="microphone;"></iframe>
  </div>
</template>
<script>

export default {
  name: 'ImView',
  data () {
    return {
      imSrc: process.env.VUE_APP_IM_URL,
      account: {
        token: '',
        chatId: '',
        chatKey: ''
      }
    }
  },
  computed: {},
  created () {
    const that = this
    window.addEventListener('message', function (event) {
      if (event.data) {
        if (event.data.cmd === 90001) {
          event.data.userInfo.unReadCount = event.data.userInfo.unReadCount === 0 ? 1 : event.data.userInfo.unReadCount
          that.$emit('onNewMessage', event.data.userInfo)
        } else if (event.data.cmd === 80001) {
          that.closeClick()
        }
      }
    }, false)
  },
  methods: {
    closeClick () {
      this.$emit('onClosed')
    },
    login (token, chatId, chatKey) {
      this.account.token = token
      this.account.chatId = chatId
      this.account.chatKey = chatKey
    },
    openSession (chatId) {
      this.$refs.im.contentWindow.postMessage({cmd: 1, chatId: chatId}, '*')
    }
  }
}
</script>
<style lang="scss" scoped>
.im-box {
  z-index: 9999;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, .3);
}

.icon {
  color: #fff;
  position: absolute;
  font-size: 30px;
  right: 50px;
  top: 50px;
  cursor: pointer;
}
</style>
